import { ApiResponse } from "./RequestManager.class";

export type ApiServiceEndpointResponse<T = any> = ApiResponse<T>;

export type ApiServiceEndpoint<T = any> = (...args: any[]) => Promise<ApiResponse<T>>;

export class MethodNotImplementedError extends Error {
    constructor() {
        super(`This method has not been implemented by the extending class`);

        // Circumventing Typescript's breaking changes in 2.1
        // https://github.com/microsoft/TypeScript-wiki/blob/81fe7b91664de43c02ea209492ec1cea7f3661d0/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, MethodNotImplementedError.prototype);
    }
}

export class EndpointUndefinedError extends Error {
    constructor(key: string) {
        super(`Endpoint ${key} is not defined on the current collection.`);

        // Circumventing Typescript's breaking changes in 2.1
        // https://github.com/microsoft/TypeScript-wiki/blob/81fe7b91664de43c02ea209492ec1cea7f3661d0/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, EndpointUndefinedError.prototype);
    }
}

export class EndpointNotImplementedError extends Error {
    constructor(key: string) {
        super(`Endpoint ${key} has not been implemented on the current collection.`);

        // Circumventing Typescript's breaking changes in 2.1
        // https://github.com/microsoft/TypeScript-wiki/blob/81fe7b91664de43c02ea209492ec1cea7f3661d0/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, EndpointUndefinedError.prototype);
    }
}

export class HttpError extends Error {
    public status: number;

    constructor(message: string, status: number) {
        super(message);
        this.status = status;

        // Ensures the prototype chain is correctly restored
        Object.setPrototypeOf(this, HttpError.prototype);
    }
}